// extracted by mini-css-extract-plugin
export default {"RemoveDeliveryTypeModal":"RemoveDeliveryTypeModal_RemoveDeliveryTypeModal__MNoe5","modalHeader":"RemoveDeliveryTypeModal_modalHeader__KVdAi"};